import { appConfig }  from '../../config';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../fetchTools';

export { getStatsWidgetData }  from './statsWidget';
export { getStatsTableData }  from './statsTable';
export { getScoreCardData }  from './scoreCard';
export { getStatsGraphData }  from './statsGraph';
export { getStatsCardData }  from './statsCard';
export { getEarningGraphData }  from './earningGraph';
export { getTeamMatesData }     from './teamMates';
export { getUserInfoData }      from './userInfos';
export { getLocationMenuData }      from './locationMenu';
export { login }      from './login';


export const getCreateFixtureData = () => {
  const url = `${getLocationOrigin()}/eagleeye/get_details_for_fixture_creation`;
  const options = {...defaultOptions};

  return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => data)
    .catch(error => error);
};



// WEBPACK FOOTER //
// ./src/app/services/API/index.js